import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userID: null,
  token: null,
};

const userSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.userID = action.payload.userID;
      state.token = action.payload.token;
    },
    logout: (state) => {
      state.userID = null;
      state.token = null;
    },
  },
});

export const { setUser, logout } = userSlice.actions;
export default userSlice.reducer;
